import { createContext } from "react";

export const UserActivityContext = createContext();
